"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var billing_rate_serializer_1 = require("./billing-rate.serializer");
var resource_service_1 = require("../../shared/resource.service");
var BillingRateService = /** @class */ (function (_super) {
    __extends(BillingRateService, _super);
    function BillingRateService(http) {
        return _super.call(this, http, 'LOCAL:/assets/files/billing_rates.json', new billing_rate_serializer_1.BillingRateSerializer()) || this;
    }
    return BillingRateService;
}(resource_service_1.ResourceService));
exports.BillingRateService = BillingRateService;
